import avatars from '../../constants/avatars';
import { isSmartPhone } from '../../utilities/helper';
import Marquee from 'react-fast-marquee';
import './index.css';
import { useEffect, useState } from 'react';
const AvatarAnimation = () => {
  const avatarList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  const [isLandscape, setIsLandscape] = useState(
    isSmartPhone && window.innerWidth > window.innerHeight
  );

  useEffect(() => {
    window.addEventListener('orientationchange', () => {
      setIsLandscape(isSmartPhone && window.innerWidth > window.innerHeight);
    });
    window.addEventListener('resize', () => {
      setIsLandscape(isSmartPhone && window.innerWidth > window.innerHeight);
    });
  }, []);

  return (
    <Marquee
      className="avatarAnimation__marquee"
      direction="left"
      speed={30}
      gradient={false}
      style={{
        width: isSmartPhone && !isLandscape ? '77px' : '96px',
        height: isSmartPhone && !isLandscape ? '77px' : '96px'
      }}>
      {avatarList.map((avatar) => {
        return (
          <img
            className={
              isLandscape
                ? 'avatarAnimation__img__landscape'
                : isSmartPhone
                ? 'avatarAnimation__img__mWeb'
                : 'avatarAnimation__img__web'
            }
            src={avatars[avatar]}
            key={`${avatar}`}
          />
        );
      })}
    </Marquee>
  );
};
export default AvatarAnimation;
